export enum FeatureToggleEnum {
  TESTING_FF_ENABLED = 'FF_FOR_UTIL_TESTING_ENABLED',
  TESTING_FF_DISABLED = 'FF_FOR_UTIL_TESTING_DISABLED',
  TESTING_FF_UNDEFINED = 'FF_FOR_UTIL_TESTING_UNDEFINED',
  FF_DELAY_BEFORE_REDIRECT = 'FF_DELAY_BEFORE_REDIRECT',
  FF_TEMP_SHIP_113_SHOW_SHIPPING_COSTS = 'FF_TEMP_SHIP_113_SHOW_SHIPPING_COSTS',
  FF_CARD_REGISTER_TRACKING = 'FF_CARD_REGISTER_TRACKING',
  FF_CHECKOUT_DISCOUNT_CODE = 'FF_CHECKOUT_DISCOUNT_CODE',
  FF_CHECKOUT_WEB_APP_BUYER_ITALY_PROVINCES = 'FF_CHECKOUT_WEB_APP_BUYER_ITALY_PROVINCES',
  FF_ENABLED_BALEARIC_ISLANDS_DELIVERY = 'FF_ENABLED_BALEARIC_ISLANDS_DELIVERY',
  FF_CHECKOUT_PAYMENT_SOFORT = 'FF_CHECKOUT_PAYMENT_SOFORT',
  FF_PAYMENT_PAYPAL_IMMEDIATE_CAPTURING = 'FF_PAYMENT_PAYPAL_IMMEDIATE_CAPTURING',
  FF_CHECKOUT_RATEPAY_LEGAL_TERMS = 'FF_CHECKOUT_RATEPAY_LEGAL_TERMS',
  FF_CHECKOUT_SMART_BASKET = 'FF_CHECKOUT_SMART_BASKET',
  FF_CHECKOUT_EVENT_CHECKOUT_STEPPER = 'FF_CHECKOUT_EVENT_CHECKOUT_STEPPER',
  FF_CHECKOUT_INCIDENT_FROZEN_REVIEW_PAGE = 'FF_CHECKOUT_INCIDENT_FROZEN_REVIEW_PAGE',
  FF_TMP_NO_SPACES_FIELD = 'FF_TMP_NO_SPACES_FIELD',
  FF_TIER_TWO_ENDPOINT_CSS_TO_BUYER_ACCOUNT = 'FF_TIER_TWO_ENDPOINT_CSS_TO_BUYER_ACCOUNT',
  FF_TRACK_IDAM_AUTOLOGIN = 'FF_TRACK_IDAM_AUTOLOGIN',
  FF_ENABLE_ITALY_SPLIT_PAYMENT = 'FF_ENABLE_ITALY_SPLIT_PAYMENT',
  FF_TRACK_MISSING_CHECKOUT_ADDRESSES = 'FF_TRACK_MISSING_CHECKOUT_ADDRESSES',
  FF_FLIXMEDIA_DYSON_INTEGRATION = 'FLIXMEDIA_DYSON_INTEGRATION',
  FF_NEW_ON_HEADER_REGISTER_CLICK = 'FF_NEW_ON_HEADER_REGISTER_CLICK',
  FF_AUTH_BUTTONS_CLICK_GA_TRACKING = 'FF_AUTH_BUTTONS_CLICK_GA_TRACKING',

  FF_EXTERNAL_CHECKOUT_ADDRESS_STEP = 'FF_EXTERNAL_CHECKOUT_ADDRESS_STEP',
  FF_SL_NG_REGISTER_EXTERNAL_REDIRECTION = 'FF_SL_NG_REGISTER_EXTERNAL_REDIRECTION',
  FF_CHECKOUT_REVIEW_ORDER_OPT_OUT_LEGITIMATE_COMMS = 'FF_CHECKOUT_REVIEW_ORDER_OPT_OUT_LEGITIMATE_COMMS',
  FF_CHECKOUT_ADDRESS_PHONE_NUMBER_INPUT_IS_ENABLED = 'FF_CHECKOUT_ADDRESS_PHONE_NUMBER_INPUT_IS_ENABLED',
  FF_BLACK_FRIDAY_COUNTDOWN = 'FF_BLACK_FRIDAY_COUNTDOWN',
  FF_DISABLE_SUPPORT_PHONE_NO = 'FF_DISABLE_SUPPORT_PHONE_NO',
  FF_CART_WEB_APP_BUYER_VALUE_ADDED_SERVICES = 'FF_CART_WEB_APP_BUYER_VALUE_ADDED_SERVICES',
  FF_CHECKOUT_RATEPAY_DEVICE_FINGERPRINT = 'FF_CHECKOUT_RATEPAY_DEVICE_FINGERPRINT',
  FF_CHECKOUT_PAYPAL_BUYER_COUNTRY_TEST_ENV = 'FF_CHECKOUT_PAYPAL_BUYER_COUNTRY_TEST_ENV',
  FF_CHECKOUT_PAYPAL_PAYLATER = 'FF_CHECKOUT_PAYPAL_PAYLATER',
  FF_CART_NPS_SURVEY_THANK_YOU_PAGE = 'FF_CART_NPS_SURVEY_THANK_YOU_PAGE',
  FF_CHECKOUT_ASSISTED_SALES_PAYMENT_ERROR = 'FF_CHECKOUT_ASSISTED_SALES_PAYMENT_ERROR',
  FF_CHECKOUT_REVIEW_ALCOHOL = 'FF_CHECKOUT_REVIEW_ALCOHOL',
  FF_CHECKOUT_TOGGLE_BACK_BUTTON = 'FF_CHECKOUT_TOGGLE_BACK_BUTTON',
  FF_CHECKOUT_REQUIRES_VIES_VALIDATION = 'FF_CHECKOUT_REQUIRES_VIES_VALIDATION',
  FF_SPECIAL_NEWSLETTER_TEXT = 'FF_SPECIAL_NEWSLETTER_TEXT',
  FF_POSTAL_CODE_WARNING_ALERT = 'FF_POSTAL_CODE_WARNING_ALERT',
  FF_MACO_FR_FOOTER_ENABLE_SOFORT = 'FF_MACO_FR_FOOTER_ENABLE_SOFORT',
  ZERO_RESULT_OUT_OF_SCOPE_CATEGORIES = 'ZERO_RESULT_OUT_OF_SCOPE_CATEGORIES',
  FF_IMPERSONATION_SESSION_EXTEND = 'FF_IMPERSONATION_SESSION_EXTEND',
  CATEGORY_URL_IDENTIFIER = 'CATEGORY_URL_IDENTIFIER',
  FF_CHECKOUT_PAYMENT_VALIDATE_IBAN = 'FF_CHECKOUT_PAYMENT_VALIDATE_IBAN',
  FF_CHECKOUT_PAYMENT_METHOD_SORT = 'FF_CHECKOUT_PAYMENT_METHOD_SORT',
  FF_CHECKOUT_ADDRESS_GAURD = 'FF_CHECKOUT_ADDRESS_GAURD',
  FF_CHECKOUT_REVIEW_PROMO_DISABLE = 'FF_CHECKOUT_REVIEW_PROMO_DISABLE',
  FF_SL_ENABLE_SUBSIDIARY_REDIRECTION = 'FF_SL_ENABLE_SUBSIDIARY_REDIRECTION',
  PRODUCT_CARDS_CAROUSELS_RESTYLE = 'PRODUCT_CARDS_CAROUSELS_RESTYLE',
  FF_ALLOW_CARD_TOKENIZATION = 'FF_ALLOW_CARD_TOKENIZATION',
  FF_ENABLE_RAVELIN_DEVICE_ID = 'FF_ENABLE_RAVELIN_DEVICE_ID',
  FF_BOE_STORE_PAYMENT_METHODS = 'FF_BOE_STORE_PAYMENT_METHODS',
  REGION_SELECTOR = 'REGION_SELECTOR',
  FF_ALLOW_CARD_TOKENIZATION_SEPADD = 'FF_ALLOW_CARD_TOKENIZATION_SEPADD',
  FF_CHECKOUT_PAYMENT_RATEPAY_MOBILENUMBER = 'FF_CHECKOUT_PAYMENT_RATEPAY_MOBILENUMBER',
  FF_SUBSIDIARY_CONFIGURATION_PER_ACCOUNT = 'FF_SUBSIDIARY_CONFIGURATION_PER_ACCOUNT',
  FF_CCS_GENESYS_ACTIVATION = 'FF_CCS_GENESYS_ACTIVATION',
  FF_CHECKOUT_RESEARCH_PANEL_MODAL = 'FF_CHECKOUT_RESEARCH_PANEL_MODAL',
  FF_SL_NG_REVIEW_PAGE_VAT_SECTION = 'FF_SL_NG_REVIEW_PAGE_VAT_SECTION',
  FF_SL_REVIEW_PAGE_PHONE_CONSENT_CHECKBOX = 'FF_SL_REVIEW_PAGE_PHONE_CONSENT_CHECKBOX',
  FF_NL_DISCOUNT_5 = 'FF_NL_DISCOUNT_5',
  FF_NEW_ENERGY_LABEL = 'FF_NEW_ENERGY_LABEL',
  FF_OPTIMIZELY_NEW_ID = 'FF_OPTIMIZELY_NEW_ID',
  FF_TMP_ODR_1741_USE_EXTERNAL_LINK_TO_OHP_FROM_MY_ORDERS_TAB = 'FF_TMP_ODR_1741_USE_EXTERNAL_LINK_TO_OHP_FROM_MY_ORDERS_TAB',
  FF_SL_COMBINED_CONSENT_CHECKBOX_EMAIL_PHONE = 'FF_SL_COMBINED_CONSENT_CHECKBOX_EMAIL_PHONE',
  FF_CHECKOUT_SKIP_CART_INITIALIZE = 'FF_CHECKOUT_SKIP_CART_INITIALIZE',
  FF_SL_NG_EXPONEA_SESSION_BUGFIX = 'FF_SL_NG_EXPONEA_SESSION_BUGFIX',
  FF_CART_2MH_CONSOLIDATION = 'FF_CART_2MH_CONSOLIDATION',
  FF_CHECKOUT_PAYMENT_GAEVENTS = 'FF_CHECKOUT_PAYMENT_GAEVENTS',
  FF_SNL_ENCODING_DECODING_LOCAL_ADDRESS = 'FF_SNL_ENCODING_DECODING_LOCAL_ADDRESS',
  FF_CART_IGNORE_NOTIFICATION_FLAG_SETTING = 'FF_CART_IGNORE_NOTIFICATION_FLAG_SETTING',
  FF_SUPER_SAVINGS = 'FF_SUPER_SAVINGS'
}

export interface KeyAccountsConfigFF {
  [key: string]: AccountData;
}

interface AccountData {
  minimum_total_threshold?: number;
  hasToShowKeyAccountsTermsAndConditions?: boolean;
}
